<template>
  <div class="post-card section-card h-100">
    <img :src="imageUrl" :alt="post.title" class="post-image">
    <div class="p-4">
      <div class="post-date mb-2">{{ formatDate(post.createdAt) }}</div>
      <h3 class="post-title">{{ post.title }}</h3>
      <p class="post-summary">{{ post.summary }}</p>
      <router-link :to="{ name: 'news-detail', params: { slug: post.slug } }" class="post-link">
        Xem chi tiết
      </router-link>
    </div>
  </div>
</template>

<script>
import { resolveAssetUrl } from "../utils/asset";
import { formatDate } from "../utils/formatters";

export default {
  name: "PostCard",
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  computed: {
    imageUrl: function imageUrl() {
      return resolveAssetUrl(this.post.thumbnail);
    }
  },
  methods: {
    formatDate
  }
};
</script>

<style scoped>
.post-card {
  overflow: hidden;
}

.post-image {
  width: 100%;
  height: 220px;
  object-fit: cover;
}

.post-date {
  color: #5f7b9e;
  font-size: 14px;
  font-weight: 600;
}

.post-title {
  font-size: 22px;
  font-weight: 800;
  color: var(--water-blue);
  min-height: 62px;
}

.post-summary {
  color: var(--soft-text);
  line-height: 1.8;
}

.post-link {
  color: var(--sky-blue);
  font-weight: 700;
}
</style>

